const translatePasswordDistro = {
  message: '信息...',
  sender: '从',
  receiver: '手机号码。',
  passwordDistor: '密码分配',
};

export default translatePasswordDistro;
